import React from 'react';
import { Settings } from 'lucide-react';

interface DepthSelectorProps {
  depthStrings: {id: number, name: string, active: boolean}[];
  activeDepth: number;
  onDepthChange: (depthId: number) => void;
  onManageDepthStrings: () => void;
}

export const DepthSelector: React.FC<DepthSelectorProps> = ({
  depthStrings,
  activeDepth,
  onDepthChange,
  onManageDepthStrings
}) => {
  const activeDepthStrings = depthStrings.filter(ds => ds.active);

  return (
    <div className="inline-flex bg-gray-100 rounded-md p-0.5 sm:p-1 text-xs">
      {activeDepthStrings.map(ds => (
        // On mobile: active buttons, on desktop: just labels
        <div key={ds.id}>
          {/* Mobile: Clickable button */}
          <button
            onClick={() => onDepthChange(ds.id)}
            className={`md:hidden px-1.5 sm:px-2 py-1 rounded-md transition-colors ${
              activeDepth === ds.id
                ? 'bg-green-500 text-white font-semibold shadow-md'
                : 'text-gray-700 hover:bg-gray-50'
            }`}
          >
            {ds.name}
          </button>
          {/* Desktop: Static label */}
          <span className="hidden md:inline-block px-1.5 sm:px-2 py-1 text-gray-700">
            {ds.name}
          </span>
        </div>
      ))}
      <button
        onClick={onManageDepthStrings}
        className="px-1.5 sm:px-2 py-1 flex items-center gap-1 text-gray-600 hover:bg-gray-50 rounded-md"
      >
        <Settings className="w-3 h-3" />
      </button>
    </div>
  );
}; 